import { render, staticRenderFns } from "./DisplayModeSwitch.vue?vue&type=template&id=53c8b8cd&"
import script from "./DisplayModeSwitch.vue?vue&type=script&lang=js&"
export * from "./DisplayModeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports